export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '100%',
        },
        icon: {
          right: '24px',
        },
        select: {
          backgroundColor: 'transparent',
        },
      },
    },
  };
}
